import { call, takeEvery, put, select } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import {
  getNotifications,
  getNotificationsSuccess,
  getNotificationsFailure,
  markAsReviewed,
  markAsReviewedSuccess,
  markAsReviewedFailure,
  updateNotifications,
  updateNotificationsSuccess,
  updateNotificationsFailure,
} from './reducer'
import { notificationsApi } from '../../services/api/notifications/notifications'
import { trackException } from '../app-insights/reducer'
import { selectUser } from '../auth/selectors'

export function* getNotificationsRequest({
  payload,
}: ReturnType<typeof getNotifications>): SagaIterator {
  try {
    const notifications = yield call(notificationsApi.getNotifications, payload)
    yield put(getNotificationsSuccess(notifications))
  } catch (e) {
    yield put(getNotificationsFailure((e as Error).message))
    yield put(trackException({ e, source: 'getNotificationsRequest' }))
  }
}

export function* markAsReviewedRequest({
  payload,
}: ReturnType<typeof markAsReviewed>): SagaIterator {
  try {
    yield call(notificationsApi.markAsReviewed, payload)
    yield put(markAsReviewedSuccess(payload))

    // Get userId from state to refresh notifications
    const user = yield select(selectUser)
    if (user?.userId) {
      yield put(getNotifications({ userId: user.userId }))
    }
  } catch (e) {
    yield put(markAsReviewedFailure((e as Error).message))
    yield put(trackException({ e, source: 'markAsReviewedRequest' }))
  }
}

export function* updateNotificationsRequest({
  payload,
}: ReturnType<typeof updateNotifications>): SagaIterator {
  try {
    const notifications = yield call(notificationsApi.getNotifications, payload)
    yield put(updateNotificationsSuccess(notifications))
  } catch (e) {
    yield put(updateNotificationsFailure((e as Error).message))
    yield put(trackException({ e, source: 'updateNotificationsRequest' }))
  }
}

export function* notificationsSaga(): Generator {
  yield takeEvery(getNotifications, getNotificationsRequest)
  yield takeEvery(markAsReviewed, markAsReviewedRequest)
  yield takeEvery(updateNotifications, updateNotificationsRequest)
}
